'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_components_RecipeViewer$RecipeExt(recipe) {
  this.ZH = null;
  this.ZH = recipe;
}
export { $c_Lmealorama_components_RecipeViewer$RecipeExt as $c_Lmealorama_components_RecipeViewer$RecipeExt };
$p = $c_Lmealorama_components_RecipeViewer$RecipeExt.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_components_RecipeViewer$RecipeExt;
/** @constructor */
function $h_Lmealorama_components_RecipeViewer$RecipeExt() {
}
export { $h_Lmealorama_components_RecipeViewer$RecipeExt as $h_Lmealorama_components_RecipeViewer$RecipeExt };
$h_Lmealorama_components_RecipeViewer$RecipeExt.prototype = $p;
$p.aRH = (function() {
  var this$1 = this.ZH.cO;
  if (((this$1.indexOf("\n") | 0) !== (-1))) {
    var $x_21 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$();
    var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(this.ZH.cO, "[\n]+", 0);
    var evidence$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_reflect_ClassTag$().o0($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(xs).U.Q());
    var capacity = 0;
    var size = 0;
    var jsElems = null;
    var elementClass = evidence$1.eC();
    capacity = 0;
    size = 0;
    var isCharArrayBuilder = (elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_C.l());
    jsElems = [];
    var i = 0;
    while ((i < xs.a.length)) {
      var x1 = i;
      var x = xs.a[x1];
      if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$(), (x !== ""))) {
        var unboxedElem = (isCharArrayBuilder ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(x) : ((x === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_ArrayBuilder$().b1(elementClass) : x));
        jsElems.push(unboxedElem);
      }
      i = ((1 + i) | 0);
    }
    var xs$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_ArrayBuilder$().b5(((elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_V.l()) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Void.l() : (((elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Null$.l()) || (elementClass === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Nothing$.l())) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.l() : elementClass)), jsElems);
    var f = ((s$2) => ("\u2610 " + s$2));
    var ct__runtimeClass;
    var ct__runtimeClass = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.l();
    var len = xs$1.a.length;
    var componentType = ct__runtimeClass;
    var ys = componentType.U.U(len);
    if ((len > 0)) {
      var i$1 = 0;
      if ((xs$1 !== null)) {
        while ((i$1 < len)) {
          var $x_2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_1 = i$1;
          var x0 = xs$1.a[i$1];
          $x_2.K(ys, $x_1, f(x0));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
        while ((i$1 < len)) {
          var $x_4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_3 = i$1;
          var x0$1 = xs$1.a[i$1];
          $x_4.K(ys, $x_3, f(x0$1));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
        while ((i$1 < len)) {
          var $x_6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_5 = i$1;
          var x0$2 = xs$1.a[i$1];
          $x_6.K(ys, $x_5, f(x0$2));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
        while ((i$1 < len)) {
          var $x_10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_9 = i$1;
          var $x_7 = xs$1.a;
          var $x_8 = (i$1 << 1);
          var x0$3_$_lo = $x_7[$x_8];
          var x0$3_$_hi = $x_7[(($x_8 + 1) | 0)];
          $x_10.K(ys, $x_9, f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(x0$3_$_lo, x0$3_$_hi)));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
        while ((i$1 < len)) {
          var $x_12 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_11 = i$1;
          var x0$4 = xs$1.a[i$1];
          $x_12.K(ys, $x_11, f(x0$4));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
        while ((i$1 < len)) {
          var $x_14 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_13 = i$1;
          var x0$5 = xs$1.a[i$1];
          $x_14.K(ys, $x_13, f($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$5)));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
        while ((i$1 < len)) {
          var $x_16 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_15 = i$1;
          var x0$6 = xs$1.a[i$1];
          $x_16.K(ys, $x_15, f(x0$6));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
        while ((i$1 < len)) {
          var $x_18 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_17 = i$1;
          var x0$7 = xs$1.a[i$1];
          $x_18.K(ys, $x_17, f(x0$7));
          i$1 = ((1 + i$1) | 0);
        }
      } else if ((xs$1 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
        while ((i$1 < len)) {
          var $x_20 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_19 = i$1;
          var x0$8 = xs$1.a[i$1];
          $x_20.K(ys, $x_19, f(x0$8));
          i$1 = ((1 + i$1) | 0);
        }
      } else {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(xs$1);
      }
    }
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T($x_21.en(ys), "", "\n", "");
  } else {
    var $x_42 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$();
    var xs$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_T__split__T__I__AT(this.ZH.cO, "\\.", 0);
    var evidence$1$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_reflect_ClassTag$().o0($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$objectGetClass(xs$2).U.Q());
    var capacity$1 = 0;
    var size$1 = 0;
    var jsElems$1 = null;
    var elementClass$1 = evidence$1$1.eC();
    capacity$1 = 0;
    size$1 = 0;
    var isCharArrayBuilder$1 = (elementClass$1 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_C.l());
    jsElems$1 = [];
    var i$2 = 0;
    while ((i$2 < xs$2.a.length)) {
      var x1$1 = i$2;
      var x$1 = xs$2.a[x1$1];
      if (($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_StringOps$(), (x$1 !== ""))) {
        var unboxedElem$1 = (isCharArrayBuilder$1 ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$uC(x$1) : ((x$1 === null) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_ArrayBuilder$().b1(elementClass$1) : x$1));
        jsElems$1.push(unboxedElem$1);
      }
      i$2 = ((1 + i$2) | 0);
    }
    var xs$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_scm_ArrayBuilder$().b5(((elementClass$1 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_V.l()) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_jl_Void.l() : (((elementClass$1 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Null$.l()) || (elementClass$1 === $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_sr_Nothing$.l())) ? $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_O.l() : elementClass$1)), jsElems$1);
    var f$1 = ((s$2$1) => (("\u2610 " + s$2$1) + "."));
    var ct$1__runtimeClass;
    var ct$1__runtimeClass = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.l();
    var len$1 = xs$3.a.length;
    var componentType$1 = ct$1__runtimeClass;
    var ys$1 = componentType$1.U.U(len$1);
    if ((len$1 > 0)) {
      var i$3 = 0;
      if ((xs$3 !== null)) {
        while ((i$3 < len$1)) {
          var $x_23 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_22 = i$3;
          var x0$9 = xs$3.a[i$3];
          $x_23.K(ys$1, $x_22, f$1(x0$9));
          i$3 = ((1 + i$3) | 0);
        }
      } else if ((xs$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_I)) {
        while ((i$3 < len$1)) {
          var $x_25 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_24 = i$3;
          var x0$10 = xs$3.a[i$3];
          $x_25.K(ys$1, $x_24, f$1(x0$10));
          i$3 = ((1 + i$3) | 0);
        }
      } else if ((xs$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_D)) {
        while ((i$3 < len$1)) {
          var $x_27 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_26 = i$3;
          var x0$11 = xs$3.a[i$3];
          $x_27.K(ys$1, $x_26, f$1(x0$11));
          i$3 = ((1 + i$3) | 0);
        }
      } else if ((xs$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_J)) {
        while ((i$3 < len$1)) {
          var $x_31 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_30 = i$3;
          var $x_28 = xs$3.a;
          var $x_29 = (i$3 << 1);
          var x0$12_$_lo = $x_28[$x_29];
          var x0$12_$_hi = $x_28[(($x_29 + 1) | 0)];
          $x_31.K(ys$1, $x_30, f$1($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(x0$12_$_lo, x0$12_$_hi)));
          i$3 = ((1 + i$3) | 0);
        }
      } else if ((xs$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_F)) {
        while ((i$3 < len$1)) {
          var $x_33 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_32 = i$3;
          var x0$13 = xs$3.a[i$3];
          $x_33.K(ys$1, $x_32, f$1(x0$13));
          i$3 = ((1 + i$3) | 0);
        }
      } else if ((xs$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_C)) {
        while ((i$3 < len$1)) {
          var $x_35 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_34 = i$3;
          var x0$14 = xs$3.a[i$3];
          $x_35.K(ys$1, $x_34, f$1($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bC(x0$14)));
          i$3 = ((1 + i$3) | 0);
        }
      } else if ((xs$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_B)) {
        while ((i$3 < len$1)) {
          var $x_37 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_36 = i$3;
          var x0$15 = xs$3.a[i$3];
          $x_37.K(ys$1, $x_36, f$1(x0$15));
          i$3 = ((1 + i$3) | 0);
        }
      } else if ((xs$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_S)) {
        while ((i$3 < len$1)) {
          var $x_39 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_38 = i$3;
          var x0$16 = xs$3.a[i$3];
          $x_39.K(ys$1, $x_38, f$1(x0$16));
          i$3 = ((1 + i$3) | 0);
        }
      } else if ((xs$3 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_Z)) {
        while ((i$3 < len$1)) {
          var $x_41 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$();
          var $x_40 = i$3;
          var x0$17 = xs$3.a[i$3];
          $x_41.K(ys$1, $x_40, f$1(x0$17));
          i$3 = ((1 + i$3) | 0);
        }
      } else {
        throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(xs$3);
      }
    }
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_sc_IterableOnceOps__mkString__T__T__T__T($x_42.en(ys$1), "", "\n", "");
  }
});
var $d_Lmealorama_components_RecipeViewer$RecipeExt = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_components_RecipeViewer$RecipeExt, "mealorama.components.RecipeViewer$RecipeExt", ({
  I2: 1
}));
export { $d_Lmealorama_components_RecipeViewer$RecipeExt as $d_Lmealorama_components_RecipeViewer$RecipeExt };
//# sourceMappingURL=mealorama.components.-Recipe-Viewer$-Recipe-Ext.js.map
